module.exports = __webpack_public_path__ + "img/ai.93fdaa2e.svg";